import React from 'react';
import { Typography, BottomNavigation } from '@material-ui/core';


const Footer = () => {
    return (
        <BottomNavigation style={{justifyContent: 'center', alignItems: 'center'}}>
            <Typography variant="subtitle1">Made with <span style={{color: "red"}}>❤</span> by <a href="https://github.com/pranav-yadav" style={{textDecoration: 'none', color: 'tomato'}}><em>Pranav Yadav</em></a></Typography>
        </BottomNavigation>
    )
}

export default Footer;
